export const safeStorage = {
  get: (key) => { try { return window.localStorage.getItem(key); } catch { return undefined; } },
  set: (key, value) => { try { window.localStorage.setItem(key, value); return true; } catch { return false; } },
  remove: (key) => { try { window.localStorage.removeItem(key); } catch { /* storage unavailable */ } },
};
